module.exports = __webpack_public_path__ + "img/dice-one.215d238e.svg";